const getUserProfileObj = userprofile => {
  return {
    userId: userprofile?.tokenizedUserId || userprofile?.userId,
    encryptedTaxId: userprofile?.tokenizedEncryptedTaxId || userprofile?.encryptedTaxId,
    emailAddress: userprofile?.tokenizedEmailAddress || userprofile?.emailAddress,
    domain: window?.location?.hostname,
  };
};

const encodeAndSanitizeValue = value => {
  return btoa(value)
    .replace(/\+/g, '_@_')
    .replace(/\//g, '_@@_')
    .replace(/=/g, '_@@@_');
};

export function getFeatureFlagTarget(userprofile) {
  const { userId, encryptedTaxId, emailAddress, domain } = getUserProfileObj(userprofile);

  if (userId && encryptedTaxId) {
    return {
      identifier: encodeAndSanitizeValue(userId),
      name: encodeAndSanitizeValue(encryptedTaxId),
      attributes: {
        key: userId,
        email: emailAddress,
        encryptedTaxId: encryptedTaxId,
        domain: window?.location?.hostname,
      },
    };
  }
  return {
    identifier: 'Initial_Load',
    anonymous: true,
    attributes: {
      domain: domain,
    },
  };
}
